// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__3btIK","list_container":"card_list_container__1yEqr"};